import React from 'react';
import {Button, Col, Form, Icon, Input, message, Modal, Row} from 'antd';
import {form_item_size} from '@common/theme';
import {action, observable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import fetchUrl from '@service/fetchUrl';
import service from '@service/index';
import login_user_store from '@store/LoginUser/LoginUserStore';

@Form.create()
@observer
class SetPassword extends React.Component {

    @observable
    submitting = false;

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            // console.log('Received values of form: ', values);
            if (!err) {

                if (values.oldPassword == values.password) {
                    message.error('新密码和旧密码不能一样', 3);
                    return
                }

                runInAction(() => {
                    this.submitting = true;
                });
                let result = await service.fetchData({
                    path: fetchUrl.user.setPassword,
                    params: {
                        oldpwd: values.oldPassword,
                        newpwd: values.password
                    }
                });
                runInAction(() => {
                    this.submitting = false;
                });
                if (result.success) {
                    // message.success('密码修改成功.', 3);

                    Modal.success({
                        title: '提示',
                        content: '密码修改成功',
                        onOk() {
                            login_user_store.logout();
                        },
                    });
                } else {
                    message.error(`密码修改失败. ${result.error.error_data}`, 3);
                }
            }
        });
    };

    @observable
    password_input_type = 'password';

    @action
    togglePasswordInputType = () => {
        this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
    }

    resetFormValue = e => {
        this.props.form.resetFields();
    }

    render() {

        let outerStyle = {
            'textAlign': 'center',
            'minHeight': '100vh',
            'paddingTop': '50px'
        };

        // let formItemStyle = {
        //   textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80px'
        // };

        const FormLayoutConfigs = {
            responsive: {
                xxl: {offset: 8, span: 8},
                xl: {offset: 8, span: 8},
                lg: {offset: 8, span: 8},
                md: {offset: 8, span: 8},
                sm: {offset: 8, span: 8},
                xs: {offset: 8, span: 8}
            },
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                }
            }
        };

        let {getFieldDecorator} = this.props.form;

        return (
            <div style={outerStyle}>
                <div style={{height: '100px'}}></div>
                <Row>
                    <Form onSubmit={this.handleSubmit}>
                        <Col {...FormLayoutConfigs.responsive}>
                            <Form.Item {...FormLayoutConfigs.formItemLayout} label='请输入旧密码'>
                                {
                                    getFieldDecorator('oldPassword', {
                                        rules: [
                                            {
                                                validator: (rule, value, cb) => {
                                                    if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/.test(value))) {
                                                        cb('密码必须为6-18位数字与字母组合')
                                                    } else {
                                                        cb()
                                                    }
                                                }
                                            }
                                        ],
                                        // initialValue: 'fdawfweEQ12'
                                    })(
                                        <Input
                                            placeholder='请输入旧密码'
                                            size={form_item_size}
                                            type={this.password_input_type}
                                            addonAfter={
                                                <Icon size={form_item_size} type="eye"
                                                      onClick={this.togglePasswordInputType}/>
                                            }/>
                                    )
                                }
                            </Form.Item>
                        </Col>
                        <Col {...FormLayoutConfigs.responsive}>
                            <Form.Item {...FormLayoutConfigs.formItemLayout} label='请输入新密码'>
                                {
                                    getFieldDecorator('password', {
                                        rules: [
                                            {
                                                validator: (rule, value, cb) => {
                                                    if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/.test(value))) {
                                                        cb('密码必须为6-18位数字与字母组合')
                                                    } else {
                                                        cb()
                                                    }
                                                }
                                            }
                                        ],
                                        // initialValue: 'fdawfweEQ12'
                                    })(
                                        <Input
                                            placeholder='请输入新密码'
                                            size={form_item_size}
                                            type={this.password_input_type}
                                            addonAfter={
                                                <Icon size={form_item_size} type="eye"
                                                      onClick={this.togglePasswordInputType}/>
                                            }/>
                                    )
                                }
                            </Form.Item>
                        </Col>
                        <Col {...FormLayoutConfigs.responsive}>
                            <Form.Item {...FormLayoutConfigs.formItemLayout} label='密码验证'>
                                {
                                    getFieldDecorator('repassword', {
                                        rules: [
                                            {
                                                validator: (rule, value, cb) => {
                                                    if (value !== this.props.form.getFieldValue('password')) {
                                                        cb("两次输入不一致！");
                                                    } else {
                                                        cb();
                                                    }
                                                }
                                            }
                                        ],
                                        // initialValue: 'fdawfweEQ12'
                                    })(
                                        <Input
                                            placeholder='请再次验证新密码'
                                            size={form_item_size}
                                            type={this.password_input_type}
                                            addonAfter={
                                                <Icon size={form_item_size} type="eye"
                                                      onClick={this.togglePasswordInputType}/>
                                            }/>
                                    )
                                }
                            </Form.Item>
                        </Col>
                        <Col {...FormLayoutConfigs.responsive}>
                            <Form.Item
                                {...FormLayoutConfigs.formItemLayout}
                                colon={false}
                                label={(
                                    <span style={{
                                        opacity: 0
                                    }}>.</span>
                                )}
                            >
                                <Button htmlType="reset" size={form_item_size} onClick={this.resetFormValue}
                                        style={{marginRight: '50px'}}>清空</Button>
                                <Button type="primary" htmlType="submit" size={form_item_size}
                                        loading={this.submitting}>确认修改</Button>
                            </Form.Item>
                        </Col>
                    </Form>
                </Row>
            </div>
        );
    }

}

export default SetPassword;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Setting/SetPassword/SetPassword.jsx